'use client'

import { forwardRef, useImperativeHandle, useState } from "react"
import styles from "./ua.module.scss";

const Slideout = forwardRef((props, ref) => {
  
  const [visible,setVisible] = useState(false)
  
  const dir = props.dir || "RL"
  const showClass = styles['sl' + dir + 'Show']
  
  
  const toggle = () => {
    setVisible(!visible)
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <div className={ styles.sl + ' ' + styles['sl' + dir] + ' ' + (visible ? showClass : '')} style={props.style || {}} aria-hidden={!visible}>
    { visible ? props.children : null }
  </div>
  
})

Slideout.displayName = 'Slideout';
export default Slideout